import React, { Component } from 'react'

class Resume extends Component {
  render() {
    return (
      <section>
        <div className="container">
          <p>Resume</p>
        </div>
      </section>
    )
  }
}

export default Resume